<script>
  export let title;
  export let description;
  export let handlePrevious;
  export let handleNext;
  export let isDisabled = false;
</script>

<div class="with-form">
  <h3 class="title is-4">{title}</h3>
  <p class="description">{description}</p>
  <form
    on:submit|preventDefault={() => {
      handleNext && handleNext();
    }}>
    <slot />
    <div class="columns buttons">
      {#if handlePrevious}
        <div class="column">
          <button class="button is-primary is-fullwidth" type="button" on:click={handlePrevious}>Previous</button>
        </div>
      {/if}

      {#if handleNext}
        <div class="column">
          <button class="button is-primary is-fullwidth" type="submit" disabled={isDisabled}>Next</button>
        </div>
      {/if}
    </div>
  </form>
</div>
